import {
  Input,
  Select,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/I-CONTA.png";
import "./adminPage.css";
import { collection, doc, getDocs, setDoc } from "firebase/firestore";
import { db, storage } from "../../firebase";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";

export default function AdminPage({ user }) {
  const [docs, setDocs] = useState([]);
  const [successDelete, setSuccessDelete] = useState("false");
  const [successUpdate, setSuccessUpdate] = useState("false");
  const [loading, setLoading] = useState(false);
  const [userr, setUserr] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!user || !user.isAdmin) {
      navigate("/");
    } else {
      getData();
    }
  }, [successDelete, successUpdate]);
  const getData = async () => {
    setLoading(true);
    let data = [];
    const querySnapshot = await getDocs(collection(db, "users"));
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      data.push(doc.data());
    });
    setLoading(false);
    setDocs(data);
  };
  const handleChange = (e) => {
    let docu = docs.find((r) => r.email === e.target.value);
    setUserr(docu);
  };
  const uploadDocument = async (e) => {
    const file = e.target.files[0];
    const storageRef = ref(storage, "docs/" + file.name);
    const uploadTask = uploadBytesResumable(storageRef, file, file.type);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
      },
      (error) => {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        alert(error.message);
      },
      () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          let doca = userr.documents;
          doca.push({ link: downloadURL, title: file.name });
          await setDoc(doc(db, "users", userr.email), {
            email: userr.email,
            documents: doca,
            isAdmin: userr.isAdmin,
            name:userr.name
          });
          setSuccessUpdate(downloadURL);
          alert("Document Uploaded");
        });
      }
    );
  };
  const deleteDocument = async (e) => {
    try {
      let doca = userr.documents;
      let s = doca.filter((r) => e.link !== r.link);
      const u = {
        email: userr.email,
        documents: s,
        isAdmin: userr.isAdmin,
        name:userr.name
      }
      await setDoc(doc(db, "users", userr.email), u);
      setUserr(u)
      setSuccessDelete(s);
      alert("Document Deleted");
    } catch (error) {
      alert(error.message);
    }
  };
  return (
    <>
      {loading ? (
        <div>Loading</div>
      ) : (
        <>
          <div className="iconta__admin-navbar">
            <div className="iconta__admin-navbar_logo">
              <img src={logo} alt="logo" />
            </div>
            <div className="iconta__admin-navbar_container">
              <h1>Administrator</h1>
            </div>

            <div />
          </div>

          <div className="admin_back">
            <div className="admin_document">
              <div
                className="iconta__formular-container_3"
                style={{ flexDirection: "column" }}
              >
                <Text>Choose User</Text>
                <Select
                  placeholder="Select option"
                  onChange={(e) => handleChange(e)}
                >
                  {docs.map((e) => (
                    <option value={e.email}>{e.name}</option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="admin_boxs">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex" }}>
                  <h1>Upload Dcouments</h1>
                  <Input type="file" width="200px" onChange={uploadDocument} />
                </div>
                <h3>Delete Documents</h3>
              </div>
              <hr></hr>

              <TableContainer>
                <Table variant="simple">
                  <TableCaption>
                    Documents Uploaded to User {userr?.email}{" "}
                  </TableCaption>
                  <Thead>
                    <Tr>
                      <Th>Title</Th>
                      <Th>Open</Th>
                      <Th>Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {userr &&
                      userr.documents.length > 0 &&
                      userr.documents.map((e) => (
                        <Tr>
                          <Td>{e.title}</Td>
                          <Td
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              window.open(e.link, "_blank").focus()
                            }
                          >
                            Click here to view
                          </Td>
                          <Td
                            style={{ cursor: "pointer" }}
                            onClick={() => deleteDocument(e)}
                          >
                            Delete Document
                          </Td>
                        </Tr>
                      ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </>
      )}
    </>
  );
}
